export let BackgroundVideo = (props) => {
    return <video
        autoPlay
        loop
        muted
        playsInline
        {...props}
    />
}